import { chunkSubstr } from ".././utils";

export const chunck = {
  id: "my-plugin",
  beforeInit: function(chart) {
    const calculateMaxLines = [];
    chart.data.labels.forEach(function(e, i, a) {
      a[i] = chunkSubstr(e, 60);
      calculateMaxLines.push(a[i].length);
    });
  }
};
